<template>
<div>
   <section class="about1bb">
 <NavBar />      
 <div class="insideabout1bb">
  <div class="techaboutbb">
<p class="smartaboutbb">Glance through our blog and view <br> the amazing blog contents of swychr.</p>

 
</div>
</div> 
  </section> 

      <h2 class="question">Welcome to  SwyChr Blog </h2>
<section class="bloggers">
 <div class="jmartins">

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Virginia">
  Why SwyChr Is the Best App <br> to Send Money from Virginia <br> to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to <br> send money
   from Virginia to anywhere in <br>  Africa without long bank queues, high</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 

</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Texas">
  Why SwyChr Is the Best App <br> to Send Money from Texas <br> to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to <br>send money from Texas
  to anywhere in <br>  Africa without long bank queues, high...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Southcarolina">
  Why SwyChr Is the Best App <br> to Send Money from South <br>Carolina to Over 18 African<br> 
  Countries</a></li></div>
<p class="sabath1">Are you looking for the easiest way to  send money
  from South Carolina to anywhere in  Africa without long bank queues...</p>
 <div class="face">
<p class="face-son">December 29, 2025 </p> <span class="face-cuzo">
By </span>   <span class="face-cuzo1"><li class="face-jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>

 </div> 
</section>
    

<section class="bloggers1">
 <div class="jmartins">

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Ohio">
  Why SwyChr Is the Best App <br> to Send Money from Ohio <br> to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to <br> send money
   from Ohio to anywhere in <br>  Africa without long bank queues, high</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 

</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky2"><a href="Northcarolina">
  Why SwyChr Is the Best App <br> to Send Money from North <br>Carolina to Over 18 African <br>
  Countries</a></li></div>
<p class="sabath2">Are you looking for the easiest way to <br>send money from North Carolina
  to<br>  anywhere in  Africa without long bank...</p>
 <div class="pius2">
<p class="pius-son2">December 29, 2025 </p> <span class="pius-cuzo2">
By </span>   <span class="pius-cuzo3"><li class="jolie2"><a href="Amina">Amina</a></li></span>
</div> 
</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Newyork">
  Why SwyChr Is the Best App <br> to Send Money from New <br>York to Over 18 African<br> 
  Countries</a></li></div>
<p class="sabath1">Are you looking for the easiest way to  send money
  from New York to anywhere in  Africa without long bank queues, high...</p>
 <div class="face">
<p class="face-son">December 29, 2025 </p> <span class="face-cuzo">
By </span>   <span class="face-cuzo1"><li class="face-jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>

 </div> 
</section>


<section class="bloggers2">
 <div class="jmartins">

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Michigan">
  Why SwyChr Is the Best App <br> to Send Money from Michigan <br> to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to <br> send money
   from Michigan to anywhere in <br>  Africa without long bank queues, high</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 

</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Maryland">
  Why SwyChr Is the Best App <br> to Send Money from Maryland <br> to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to <br>send money from Maryland
  to anywhere in <br>  Africa without long bank queues, high...</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube1">  <li class="lucky1"><a href="Louisana">
  Why SwyChr Is the Best App <br> to Send Money from Louisana <br> to Over 18 African<br> 
  Countries</a></li></div>
<p class="sabath1">Are you looking for the easiest way to  send money
  from South Louisana to anywhere in  Africa without long bank queues, high...</p>
 <div class="face">
<p class="face-son">December 29, 2025 </p> <span class="face-cuzo">
By </span>   <span class="face-cuzo1"><li class="face-jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>

 </div> 
</section>

<FooterView />
</div>
 </template> 

  <script setup> 
 import NavBar from '@/components/NavBar.vue';
import FooterView from '@/components/FooterView.vue';   
 </script>


<style>
.about1bb{
  text-align: center;
  margin: 0 auto;
  padding: 0.625rem 0;
  height: auto;
  position: relative; 
  width: 100%;
  height: 50vh;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background-image: url('@/assets/images/divi.webp');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.insideabout1bb{
  padding-top: 5rem; 
  display: block;
  align-items: center;
  justify-content: center;
  width: 90vw;
  margin-top: 0; 
}

.techaboutbb{
  text-align: justify;
  line-height: 1;
  margin-left: 6.61vw; 
}

.smartaboutbb{
  margin-bottom: 0;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 2.9rem; 
  font-style: normal;
  font-weight: 600;
  line-height: 95%;
  padding-top: 0;
  margin-right: 3.125vw;
}

.mathsaboutbb{
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.960rem;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
  letter-spacing: 0.075rem; 
  margin-top: 0.5rem;
}


@media only screen and (max-width: 430px) {
  .about1bb {
    height: auto;
    min-height: 100vh;
    overflow-y: visible;
  }

  .background-image {
    width: 100%;
    height: 100%;
  }


  .insideabout1bb{
    padding-top: 4rem;
    width: 100%;
  }

  .techaboutbb {
    margin-left: 0;
    text-align: center;
    padding: 0 1.25rem;
  }

  .smartaboutbb{
    font-size: 2.1rem;
    line-height: 1.1;
    margin-bottom: 1rem;
    margin-right: 0;
  }

  .mathsaboutbb{
    font-size: 0.95rem;
    line-height: 1.5;
    letter-spacing: 0.02rem;
    padding: 0 0.5rem;
    br { display: none; } 
  }
}
  

 .question{
  text-align: justify;
   color: black;
   font-size: 70px;
   font-weight: 700;
   padding-left: 85px;
}  

.bloggers{
    padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
  color: #000;
   background-color: #f8f8f8;
   font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 120%; 
}


.bloggers1{
  text-align: center;
  width:100%; 
  margin: 0 auto;
  color: #000;
   background-color: #f8f8f8;
   font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 120%; 
}


.bloggers2{
  text-align: center;
  width:100%; 
  margin: 0 auto;
  color: #000;
   background-color: #f8f8f8;
   font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 120%; 
}

.jmartins{
  display: inline-flex;
  font-size: 20px;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: #f8f8f8;
   color: #000;
}

.studies{
  background-color: #FFFFFF;
  color: #000;
  height: 560px;
  width: 350px;
  margin: 15px;
  border-radius: 15px;
}

.villa{
  margin-top: 35px;
  border-radius: 15px;
}

.lucky{
  border: none;
 display: flex;
}

.lucky a{
text-decoration: none;
font-family: Montserrat;
font-size: 13px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-left: 20px;
margin-top: 30px;
color: #761D9F;
}

.lucky a:hover{
  color: #000;
}

.lucky1{
  border: none;
 display: flex;
 text-align: justify;
}

.lucky1 a{
text-decoration: none;
font-family: Montserrat;
font-size: 22px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px;
color: #000;
gap: 5px;
}

.lucky1 a:hover{
  color: #761D9F;
}


.lucky2{
  border: none;
 display: flex;
 text-align: justify;
}

.lucky2 a{
text-decoration: none;
font-family: Montserrat;
font-size: 21px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
color: #000;
gap: 5px;
}

.lucky2 a:hover{
  color: #761D9F;
}

.sabath{
 font-family: Montserrat;
font-size: 18px;
font-style: normal;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px; 
text-align: justify;
}

.sabath2{
  margin-top: 0;
   font-family: Montserrat;
font-size: 18px;
font-style: normal;
line-height: 1.2;
margin-left: 17px; 
text-align: justify;
}

.sabath1{
 font-family: Montserrat;
font-size: 17px;
font-style: normal;
line-height: 1.1;
margin-left: 17px;
margin-top: 5px;
padding-top: 0; 
text-align: justify;
}

.pius{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
padding-top: 0;
margin-top: 0;
margin-bottom: 100px;
}

.jolie{
  border: none;
 display: flex;
}

.jolie a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-top: 30px;
color: #000;
}

.jolie a:hover{
  color: #761D9F;
}

.pius-son{
  margin-right: 25px;
}

.pius-cuzo{
  margin-right: 10px;
}

.pius-cuzo1{
  padding-bottom:27px;
  margin-right: 56px;
}

.pius2{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
margin-bottom: 100px;
}

.jolie2{
  border: none;
 display: flex;
}

.jolie2 a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-top: 30px;
color: #000;
}

.jolie2 a:hover{
  color: #761D9F;
}

.pius-son2{
  
  margin-right: 25px;
}

.pius-cuzo2{ 
  margin-right: 10px;
 
}

.pius-cuzo3{
 margin-bottom: 28px;
 margin-right: 50px;
}


.face{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
padding-top: 0;
margin-top: 0;

}

.face-jolie{
  border: none;
 display: flex;
}

.face-jolie a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;
line-height: 120%;
color: #000;
}

.face-jolie a:hover{
  color: #761D9F;
}

.face-son{
  margin-right: 25px;
}

.face-cuzo{
  margin-right: 10px;
}

.face-cuzo1{
  margin-right: 56px;
}







@media screen and (max-width: 1024px) {
  .question {
    font-size: 45px !important; 
    padding-left: 20px !important;
    text-align: center !important;
  }

  .jmartins {
    display: flex !important;
    flex-wrap: wrap !important; 
    justify-content: center !important;
    padding: 0 10px !important;
  }

  .studies {
    width: 45% !important; 
    height: auto !important;
    margin: 10px !important;
    padding-bottom: 20px !important;
  }

  .villa {
    width: 90% !important;
    height: auto !important;
  }

  .sabath, .sabath1, .sabath2 {
    br { display: none; } 
  }
}


@media screen and (max-width: 430px) {
  .question {
    font-size: 28px !important;
    padding: 20px 0 !important;
    text-align: center !important;
    margin-top: 0 !important;
  }


  .bloggers, .bloggers1, .bloggers2 {
    padding: 10px 0 !important;
  }

  .jmartins {
    flex-direction: column !important; 
    width: 100% !important;
  }

  .studies {
    width: 90vw !important; 
    height: auto !important; 
    margin: 15px auto !important;
    padding-bottom: 25px !important;
  }

  .lucky1 a, .lucky2 a {
    font-size: 18px !important;
    margin-right: 15px !important;
  }

  .lucky1 br, .lucky2 br, .sabath br, .sabath1 br {
    display: none !important; 
  }

  .sabath, .sabath1, .sabath2 {
    font-size: 15px !important;
    padding-right: 15px !important;
  }

  
  .pius, .pius2, .face {
    width: 100% !important;
    justify-content: flex-start !important;
    padding-left: 17px !important;
    margin-bottom: 0 !important;
    font-size: 14px !important;
  }

  .pius-cuzo1, .pius-cuzo3, .face-cuzo1 {
    margin-right: 0 !important;
    padding-bottom: 0 !important;
  }

  .jolie a, .jolie2 a, .face-jolie a {
    margin-top: 0 !important;
    font-size: 14px !important;
  }
}
</style>